import { render, staticRenderFns } from "./activeuser.vue?vue&type=template&id=e5ce5b82"
import script from "./activeuser.vue?vue&type=script&lang=js"
export * from "./activeuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports